/**
 * Caution: Consider this file when using react-scripts
 * 
 * You may delete this file and its occurrences from the project filesystem if you are using GatsbyJS or NextJS version
 */
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import WithLayout from 'WithLayout';
import { Main as MainLayout, Minimal as MinimalLayout, DocsLayout } from './layouts';



import {
  Home as HomeView,
  IndexView,
  Giveaways as GiveawaysView,
  Videos as VideosView,
  Agency as AgencyView,
  CareerListing as CareerListingView,
  CareerListingMinimal as CareerListingMinimalView,
  CareerOpening as CareerOpeningView,
  ContactPage as ContactPageView,
  Coworking as CoworkingView,
  Elearning as ElearningView,
  Enterprise as EnterpriseView,
  Service as ServiceView,
  WebBasic as WebBasicView,
  DesktopApp as DesktopAppView,
  Expo as ExpoView,
  Startup as StartupView,
  DesignCompany as DesignCompanyView,
  MobileApp as MobileAppView,
  JobListing as JobListingView,
  Rental as RentalView,
  CloudHosting as CloudHostingView,
  Logistics as LogisticsView,
  IndustryLimits as IndustryLimitsView,
  MonsterDrops as MonsterDropsView,
  FrescoManorSpells as FrescoManorSpellsView,
  StatusEffects as StatusEffectsView,
  Runiverse as RuniverseView,
  RuniverseEquipment as RuniverseEquipmentView,
  RuniverseResources as RuniverseResourcesView,
  RuniverseEquipmentFresco as RuniverseEquipmentFrescoView,
  LevelUpGuide as LevelUpGuideView,
  RuniverseSupport as RuniverseSupportView,
  RuniverseAnimations as RuniverseAnimationsView,

  PixelsQuestAlinaRecipe as PixelsQuestAlinaRecipeView,
  PixelsLandInventory as PixelsLandInventoryView,
  PixelsAnimalDrops as PixelsAnimalDropsView,
  SunflowerLandHelpers as SunflowerLandHelpersView,
  SunflowerLandWinners as SunflowerLandWinnersView,
  SunflowerLandFishing as SunflowerLandFishingView,
  AxieCollection as AxieCollectionView,
  AxieDom as AxieDomView,
  AxieDomStrategy as AxieDomStrategyView,

  Ecommerce as EcommerceView,
  Pricing as PricingView,
  About as AboutView,
  HelpCenter as HelpCenterView,
  HelpCenterArticle as HelpCenterArticleView,
  PortfolioPage as PortfolioPageView,
  PortfolioMasonry as PortfolioMasonryView,
  PortfolioGrid as PortfolioGridView,
  CompanyTerms as CompanyTermsView,
  ContactPageSidebarMap as ContactPageSidebarMapView,
  ContactPageCover as ContactPageCoverView,
  AboutSideCover as AboutSideCoverView,
  BlogSearch as BlogSearchView,
  BlogNewsroom as BlogNewsroomView,
  BlogArticle as BlogArticleView,
  BlogReachView as BlogReachViewView,
  PasswordResetCover as PasswordResetCoverView,
  PasswordResetSimple as PasswordResetSimpleView,
  SigninSimple as SigninSimpleView,
  SigninCover as SigninCoverView,
  SignupSimple as SignupSimpleView,
  SignupCover as SignupCoverView,
  Account as AccountView,
  Documentation as DocumentationView,
  NotFound as NotFoundView,
  NotFoundCover as NotFoundCoverView,
} from './views';

const Routes = () => {
  return (
    <Switch>
      <Route
        exact
        path="/"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={IndexView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/home"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={HomeView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/giveaways"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={GiveawaysView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/videos"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={VideosView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/pixels/industry-limits"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={IndustryLimitsView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path={["/sunflower-land/helpers", "/sunflower-land/helps"]}
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={SunflowerLandHelpersView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/sunflower-land/helpers/winners"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={SunflowerLandWinnersView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/sunflower-land/tools/fishing"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={SunflowerLandFishingView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/axie/collection"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={AxieCollectionView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/axie-dom/power-ups"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={AxieDomView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/axie-dom/strategy"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={AxieDomStrategyView}
            layout={MainLayout}
          />
        )}
      />
      <Redirect exact from="/axie/axie-dom" to="/axie-dom/power-ups" />
      <Redirect exact from="/strategy" to="/axie-dom/strategy" />
      <Route
        exact
        path="/runiverse"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={RuniverseView}
            layout={MainLayout}
          />
        )}
      />

      <Route
        exact
        path="/runiverse/spells"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={FrescoManorSpellsView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/runiverse/monster-drops"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={MonsterDropsView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/runiverse/status-effects"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={StatusEffectsView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/runiverse/equipment/"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={RuniverseEquipmentFrescoView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/runiverse/animations/"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={RuniverseAnimationsView}
            layout={MainLayout}
          />
        )}
      />

      <Route
        exact
        path="/runiverse/equipment/all"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={RuniverseEquipmentView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/runiverse/resources"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={RuniverseResourcesView}
            layout={MainLayout}
          />
        )}
      />

      <Route
        exact
        path="/runiverse/level-up-guide"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={LevelUpGuideView}
            layout={MainLayout}
          />
        )}
      />

      <Route
        exact
        path="/runiverse/support"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={RuniverseSupportView}
            layout={MainLayout}
          />
        )}
      />

      <Route
        exact
        path="/pixels/quest/alchemist-concoction"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={PixelsQuestAlinaRecipeView}
            layout={MainLayout}
          />
        )}
      />

      <Route
        exact
        path="/pixel/animal/drops"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={PixelsAnimalDropsView}
            layout={MainLayout}
          />
        )}
      />

      <Route
        exact
        path="/pixels/animal/drops"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={PixelsAnimalDropsView}
            layout={MainLayout}
          />
        )}
      />

      <Route
        exact
        path="/pixels/land-inventory"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={PixelsLandInventoryView}
            layout={MainLayout}
            dataSource="api"
          />
        )}
      />
      <Redirect exact from="/pixels/inventory" to="/pixels/land-inventory" />
      <Redirect exact from="/pixels/land/inventory" to="/pixels/land-inventory" />

      <Route
        exact
        path="/land/inventory/v1"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={PixelsLandInventoryView}
            layout={MainLayout}
            dataSource="static"
          />
        )}
      />

      <Route
        exact
        path="/pixels/land-inventory/v1"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={PixelsLandInventoryView}
            layout={MainLayout}
            dataSource="static"
          />
        )}
      />
      <Redirect exact from="/pixels/land/inventory/v1" to="/pixels/land-inventory/v1" />

      <Route
        exact
        path="/career-listing"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={CareerListingView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/career-listing-minimal"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={CareerListingMinimalView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/career-opening"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={CareerOpeningView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/contact-page"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={ContactPageView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/coworking"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={CoworkingView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/e-learning"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={ElearningView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/enterprise"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={EnterpriseView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/discord"
        render={() => {
          window.location.href = 'https://discord.gg/NH3Yu95YVV';
          return null;
        }}
      />
      <Route
        exact
        path="/service"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={ServiceView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/web-basic"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={WebBasicView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/desktop-app"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={DesktopAppView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/expo"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={ExpoView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/agency"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={AgencyView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/startup"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={StartupView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/design-company"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={DesignCompanyView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/mobile-app"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={MobileAppView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/job-listing"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={JobListingView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/rental"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={RentalView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/cloud-hosting"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={CloudHostingView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/logistics"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={LogisticsView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/e-commerce"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={EcommerceView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/pricing"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={PricingView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/about"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={AboutView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/help-center"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={HelpCenterView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/help-center-article"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={HelpCenterArticleView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/portfolio-page"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={PortfolioPageView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/portfolio-masonry"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={PortfolioMasonryView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/portfolio-grid"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={PortfolioGridView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/company-terms"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={CompanyTermsView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/contact-sidebar-map"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={ContactPageSidebarMapView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/contact"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={ContactPageCoverView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/about-side-cover"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={AboutSideCoverView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/blog-search"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={BlogSearchView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/blog-newsroom"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={BlogNewsroomView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/blog-article"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={BlogArticleView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/blog-reach-view"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={BlogReachViewView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/password-reset-cover"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={PasswordResetCoverView}
            layout={MinimalLayout}
          />
        )}
      />
      <Route
        exact
        path="/password-reset-simple"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={PasswordResetSimpleView}
            layout={MinimalLayout}
          />
        )}
      />
      <Route
        exact
        path="/signin-simple"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={SigninSimpleView}
            layout={MinimalLayout}
          />
        )}
      />
      <Route
        exact
        path="/signin-cover"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={SigninCoverView}
            layout={MinimalLayout}
          />
        )}
      />
      <Route
        exact
        path="/signup-simple"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={SignupSimpleView}
            layout={MinimalLayout}
          />
        )}
      />
      <Route
        exact
        path="/signup-cover"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={SignupCoverView}
            layout={MinimalLayout}
          />
        )}
      />
      <Route
        exact
        path="/account"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={AccountView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/documentation"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={DocumentationView}
            layout={DocsLayout}
          />
        )}
      />
      <Route
        exact
        path="/not-found"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={NotFoundView}
            layout={MinimalLayout}
          />
        )}
      />
      <Route
        exact
        path="/not-found-cover"
        render={matchProps => (
          <WithLayout
            {...matchProps}
            component={NotFoundCoverView}
            layout={MinimalLayout}
          />
        )}
      />
      <Redirect to="/not-found-cover" />
    </Switch>
  );
};

export default Routes;
